import Swiper from 'swiper';

const initVideoCarouselSlider = () => {
    const sliders = document.querySelectorAll('[data-video-carousel-slider].swiper');
    const desktopBreakpoint = window.matchMedia('(min-width: 1024px)');

    if (!sliders.length) {
        return;
    }

    sliders.forEach((slider) => {
        const slides = slider.querySelectorAll('.swiper-slide');
        if (!slides.length) {
            return;
        }

        const prevButton = slider.querySelector('.swiper-pagination__button-prev');
        const nextButton = slider.querySelector('.swiper-pagination__button-next');
        const desktopSliderActive = slider.dataset.videoCarouselDesktopSlider !== 'false';
        let swiper = null;

        if (!prevButton || !nextButton) {
            return;
        }

        const updateButtonStates = () => {
            if (!swiper) {
                prevButton.disabled = true;
                nextButton.disabled = true;
                prevButton.classList.add('swiper-button-disabled');
                nextButton.classList.add('swiper-button-disabled');

                return;
            }

            prevButton.disabled = swiper.isBeginning;
            nextButton.disabled = swiper.isEnd;

            prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
            nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
        };

        prevButton.addEventListener('click', () => {
            if (swiper) {
                swiper.slidePrev();
            }
        });

        nextButton.addEventListener('click', () => {
            if (swiper) {
                swiper.slideNext();
            }
        });

        const initSwiper = () => {
            if (swiper) {
                return;
            }

            swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                preventClicks: false,
                preventClicksPropagation: false,
                breakpoints: {
                    740: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                },
            });

            updateButtonStates();
            swiper.on('slideChange', updateButtonStates);
        };

        const destroySwiper = () => {
            if (!swiper) {
                return;
            }

            swiper.off('slideChange', updateButtonStates);
            swiper.destroy(true, true);
            swiper = null;
            updateButtonStates();
        };

        if (desktopSliderActive) {
            initSwiper();
            return;
        }

        const syncSliderMode = () => {
            const useDesktopStaticLayout = desktopBreakpoint.matches;

            slider.classList.toggle('video-carousel__slider--desktop-static', useDesktopStaticLayout);

            if (useDesktopStaticLayout) {
                destroySwiper();
                return;
            }

            initSwiper();
        };

        syncSliderMode();
        desktopBreakpoint.addEventListener('change', syncSliderMode);
    });
};

export default initVideoCarouselSlider;
